import { render } from "./BodyForm.vue?vue&type=template&id=5950d372&ts=true"
import script from "./BodyForm.ts?vue&type=script&lang=ts"
export * from "./BodyForm.ts?vue&type=script&lang=ts"

import "./BodyForm.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/codebuild/output/src2289401972/src/codestar-connections.eu-west-1.amazonaws.com/git-http/021041300469/eu-west-1/c73932a4-e0ca-4ec0-8408-20b6c899ca8a/studyportals/BodiesEditor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__